import { useSettingsStore } from '../store'
import { HourConfigField } from './HourConfigField'

export function BiometricsHoursTab() {
  const { hourSettings, updateBiometricsHours } = useSettingsStore()
  const bio = hourSettings.biometrics

  return (
    <div className="space-y-6">
      {/* Base Setup */}
      <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg p-4">
        <h4 className="text-sm font-medium text-[var(--text-primary)] mb-3">Base Setup</h4>
        <HourConfigField
          label="Biometrics/IDV Base Setup"
          value={bio.baseSetup}
          onChange={(v) => updateBiometricsHours('baseSetup', v)}
          description="Initial biometrics configuration"
        />
      </div>

      {/* Service Levels */}
      <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg p-4">
        <h4 className="text-sm font-medium text-[var(--text-primary)] mb-3">Service Levels</h4>
        <HourConfigField
          label="Document + Review"
          value={bio.documentReview}
          onChange={(v) => updateBiometricsHours('documentReview', v)}
          description="Document check plus review screen"
        />
        <HourConfigField
          label="Document + Biometrics + Review"
          value={bio.documentBiometricsReview}
          onChange={(v) => updateBiometricsHours('documentBiometricsReview', v)}
          description="Document check plus facial similarity plus review screen"
        />
      </div>

      {/* Document & Country Config */}
      <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg p-4">
        <h4 className="text-sm font-medium text-[var(--text-primary)] mb-3">Documents</h4>
        <HourConfigField
          label="Per Document Type"
          value={bio.perDocumentType}
          onChange={(v) => updateBiometricsHours('perDocumentType', v)}
          description="Hours per additional document type"
        />
      </div>

      {/* Frontend Options */}
      <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg p-4">
        <h4 className="text-sm font-medium text-[var(--text-primary)] mb-3">Frontend Integration</h4>
        <HourConfigField
          label="Hosted OneSDK"
          value={bio.hostedOneSdk}
          onChange={(v) => updateBiometricsHours('hostedOneSdk', v)}
          description="FrankieOne hosted solution"
        />
        <HourConfigField
          label="Embedded OneSDK"
          value={bio.embeddedOneSdk}
          onChange={(v) => updateBiometricsHours('embeddedOneSdk', v)}
          description="Embedded SDK integration"
        />
        <HourConfigField
          label="Other Frontend"
          value={bio.otherFrontend}
          onChange={(v) => updateBiometricsHours('otherFrontend', v)}
          description="Custom frontend integration"
        />
      </div>

      {/* Platform */}
      <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg p-4">
        <h4 className="text-sm font-medium text-[var(--text-primary)] mb-3">Platform</h4>
        <HourConfigField
          label="Web Platform"
          value={bio.webPlatform}
          onChange={(v) => updateBiometricsHours('webPlatform', v)}
          description="Web browser support"
        />
        <HourConfigField
          label="In-App Platform"
          value={bio.inAppPlatform}
          onChange={(v) => updateBiometricsHours('inAppPlatform', v)}
          description="Mobile app integration"
        />
        <HourConfigField
          label="Both Platforms"
          value={bio.bothPlatforms}
          onChange={(v) => updateBiometricsHours('bothPlatforms', v)}
          description="Web and mobile app support"
        />
      </div>

      {/* Branding */}
      <div className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg p-4">
        <h4 className="text-sm font-medium text-[var(--text-primary)] mb-3">Branding Requirements</h4>
        <HourConfigField
          label="Rebranding Hosted OneSDK"
          value={bio.rebrandingHostedOneSDK}
          onChange={(v) => updateBiometricsHours('rebrandingHostedOneSDK', v)}
          description="Custom branding for hosted solution"
        />
        <HourConfigField
          label="Rebranding Daon"
          value={bio.rebrandingDaon}
          onChange={(v) => updateBiometricsHours('rebrandingDaon', v)}
          description="Custom Daon branding"
        />
        <HourConfigField
          label="Extended Branding"
          value={bio.extendedBranding}
          onChange={(v) => updateBiometricsHours('extendedBranding', v)}
          description="Full branding customization"
        />
        <HourConfigField
          label="Custom Redirect Page"
          value={bio.customRedirectPage}
          onChange={(v) => updateBiometricsHours('customRedirectPage', v)}
          description="Custom completion redirect"
        />
        <HourConfigField
          label="Custom Consents"
          value={bio.customConsents}
          onChange={(v) => updateBiometricsHours('customConsents', v)}
          description="Custom consent screens"
        />
        <HourConfigField
          label="Vendor Integration"
          value={bio.vendorIntegration}
          onChange={(v) => updateBiometricsHours('vendorIntegration', v)}
          description="Non-FrankieOne vendor setup"
        />
      </div>
    </div>
  )
}
